<template>
    <div class="modal fade" id="comm_log_modal" tabindex="-1" aria-labelledby="" aria-hidden="true" ref="modalEl">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Communication Log</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="container-fluid">

                        <div class="row mb-3">
                            <div class="col-2 text-end label">
                                <span class="me-2" style="color:red;">*</span>
                                <label>Date &amp; Time</label>
                            </div>
                            <div class="col-3">
                                <input type="date" v-model="commLog.date" id="log_date" data-label="Date" class="form-control">
                            </div>
                            <div class="col-3">
                                <input type="time" v-model="commLog.time" id="log_time" data-label="Time" class="form-control">
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-2 text-end label">
                                <span class="me-2" style="color:red;">*</span>
                                <label>Subject</label>
                            </div>
                            <div class="col-8">
                                <select v-model="commLog.comm_reason_id" id="comm_reason_id" class="form-select" data-label="Reason">
                                    <option v-for="reason in commReasons" :value="reason.id" :selected="commLog.comm_reason_id == reason.id">{{ reason.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-2 text-end label">
                                <span class="me-2" style="color:red;">*</span>
                                <label>Channel</label>
                            </div>
                            <div class="col-8">
                                <select v-model="commLog.channel_id" id="comm_channel_id" class="form-select" data-label="Channel">
                                    <option v-for="channel in channels" :value="channel.id" :selected="commLog.channel_id == channel.id">{{ channel.name }} &mdash; {{ channel.address }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-2 text-end label">
                                <span class="me-2" style="color:red;">*</span>
                                <label>Status</label>
                            </div>
                            <div class="col-8">
                                <select v-model="commLog.comm_status_id" id="comm_status_id" class="form-select" data-status="Status">
                                    <option v-for="status in commStatuses" :value="status.id" :selected="commLog.comm_status_id == status.id">{{ status.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2 text-end label">
                                <label>Notes</label>
                            </div>
                            <div class="col-8">
                                <textarea v-model="commLog.notes" id="notes" class="form-control" data-label="Notes">{{ commLog.notes }}</textarea>
                            </div>
                        </div>

                    </div><!--.container-fluid -->
                </div><!--.modal-body -->

                <div class="modal-footer">
                    <span class="me-2" style="color:red;">* required</span>
                    <button v-if="commLog.date && commLog.time && commLog.comm_reason_id && commLog.channel_id && commLog.comm_status_id" class="btn btn-primary" title="Save" @click="saveCommLog(); _hide()">Save</button>
                    <button v-else class="btn btn-primary disabled" title="Save" @click="saveCommLog(); _hide()">Save</button>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="commLog = {}">Cancel</button>
                </div>

            </div><!--.modal-content -->
        </div><!--.modal-dialog -->
    </div><!--.modal -->
</template>


<style scoped>
.label {
    font-weight: bold;
    padding-top: 5px;
}
</style>


<script setup>
    import { onMounted, ref } from "vue"
    import { storeToRefs } from 'pinia'
    import { Modal } from "bootstrap"
    import { useCommLogsStore } from '../../stores/comm-logs-store'
    const { commLog, commReasons, commStatuses, channels, error } = storeToRefs(useCommLogsStore())
    const { saveCommLog } = useCommLogsStore()

    // initialize modal
    let modalEl = ref(null)
    let commLogModalObj = null
    onMounted(() => {
        commLogModalObj = new Modal(modalEl.value)
    })

    function _show() {
        commLogModalObj.show()
    }
    function _hide() {
        commLogModalObj.hide()
    }
    defineExpose({ show: _show })
</script>